import { CSSProperties, useState } from "react";
import { MdChevronRight, MdMap } from "react-icons/md";
import useModalSelecaoTalhoes from "../../../hooks/useModalSelecaoTalhoes";
import {
    TalhoesListContent,
    TalhoesSection,
    SectionHeader,
    SectionTitle,
    SectionCount,
    SectionContent,
    TalhaoItemCompact,
    TalhaoInfoCompact,
    TalhaoCodigoCompact,
    TalhaoAreaCompact
} from "./styles";

type Props = {
    listItem: any[],
    title: string
    icon?: any,
    style?: CSSProperties,
    isCheckbox?: boolean
}

export function ListTalhoes({ listItem, title, icon: Icon, isCheckbox = false, ...props }: Props) {
    const [collapse, setCollapse] = useState(false);
    
    const { listTalhoesLogicos, setListTalhoesLogicos, setTalhaoLogico } = useModalSelecaoTalhoes();

    function handleSelectItem(id: string) {
      const isSelected = listTalhoesLogicos?.includes(id);
      const newSelected = isSelected
        ? listTalhoesLogicos?.filter((itemId) => itemId !== id)
        : [...listTalhoesLogicos, id];

      setListTalhoesLogicos(newSelected);
    }

    function handleClickItem(item: any) {
      if (!isCheckbox) return;
      setTalhaoLogico(item);
    }
    
    return (
         <TalhoesListContent collapse={collapse} {...props}>
          <TalhoesSection>
          <SectionHeader collapse={collapse} onClick={() => setCollapse(!collapse)}>
            <Icon size={24} />
            <SectionTitle>{title}</SectionTitle>
            <SectionCount>{listItem?.length}</SectionCount>
            <MdChevronRight className="icon-chevron" size={20} />
          </SectionHeader>
          <SectionContent collapse={collapse}>
            {listItem.map((item, index) => (
                <TalhaoItemCompact key={index} onClick={() => handleClickItem(item)}>
                  {isCheckbox ? 
                    <input 
                      type="checkbox"
                      className="talhao-checkbox-compact"
                      checked={listTalhoesLogicos?.includes(item?.talhaoId)}
                      onChange={() => handleSelectItem(item?.talhaoId)}
                      /> : '📋' }
                      {item?.geometria && <MdMap size={20} />}
                  <TalhaoInfoCompact>
                    <TalhaoCodigoCompact checked={listTalhoesLogicos?.includes(item?.talhaoId)}>{item?.codigo}</TalhaoCodigoCompact>
                    <TalhaoAreaCompact checked={listTalhoesLogicos?.includes(item?.talhaoId)}>{item?.areaPlantadaHa} ha</TalhaoAreaCompact>
                  </TalhaoInfoCompact>
                </TalhaoItemCompact>
            ))}
            </SectionContent>
            </TalhoesSection>
        </TalhoesListContent>
    )
}